import { getPublicEnvVar } from '@utils/get-env-var'
import Cookies from 'js-cookie'
import { jwtDecode } from 'jwt-decode'

export const getXPlatformToken = () => {
  /**
   * 開發模式下，使用環境變數的 x-platform-token
   * 在 apps 下新增 .env.development.local 並設定 VITE_X_PLATFORM_TOKEN
   * VITE_X_PLATFORM_TOKEN 是從 beta/alpha 站使用 Cosign 登入後的 cookie 中取得
   */
  if (getPublicEnvVar('NODE_ENV') === 'development') {
    return getPublicEnvVar('X_PLATFORM_TOKEN') || Cookies.get('x-platform-token')
  }
  return Cookies.get('x-platform-token')
}

export interface XPlatformInfo {
  iss?: string
  iat?: number
  nbf?: number
  exp?: number
  aud?: string
  sub?: number
  platformId?: number
  type?: string
  /**
   * Cosign User ID
   */
  platformUid?: string
}

export const getXPlatformTokenDecoded = () => {
  const xPlatformToken = getXPlatformToken()
  return xPlatformToken ? jwtDecode<XPlatformInfo>(xPlatformToken) : null
}

export const isUserLoggedInFn = (xPlatformInfo?: XPlatformInfo | null): xPlatformInfo is XPlatformInfo => !!xPlatformInfo?.platformUid
